// eslint-disable-next-line import/no-cycle
import AuthService from "../../AuthService";

const branch = {
  getBranch(page) {
    return AuthService.get(`/branch/branches?page=${page}`);
  },
  showBranch(id) {
    return AuthService.get(`/branch/branches/${id}`);
  },
  createBranch(data) {
    return AuthService.post("/branch/branches", data);
  },
  updateBranch(id, data) {
    return AuthService.put(`/branch/branches/${id}`, data);
  },
  deleteBranch(id) {
    return AuthService.delete(`/branch/branches/${id}`);
  },
  getBranchAll() {
    return AuthService.get("/branch/get_branch_all");
  }
};
export default branch;
